import React from 'react';
import './LogoHeader.css';

const LogoHeader = (props: any) => {
	return (
		<div className="top-logo-frame modal-disable-select">
			<div className="top-logo-frame-holder">
				<img  tabIndex={0} aria-label="V A" className="logo-icon" src={'./assets/img/va_logo.png'} />
				<div className="top-text">FIRST CARE RESPONDER</div>
				<div className="bottom-text">BLEEDING CONTROL SIMULATION</div>
			</div>
		</div>
	);
};

export default LogoHeader;
